module.exports = __webpack_public_path__ + "static/img/hair_11.b9dfdb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_11.png
// module id = Kyw5
// module chunks = 0